export class CampanhaEncarteLog {
  id: string;
  cmeId: number;
  celUsuNome: string;
  celData:number;
  celOperacao: string;
  celDetalhe: string;
}
